import { create } from 'zustand'

interface UIState {
  theme: 'light' | 'dark'
  sidebarOpen: boolean
  modals: Record<string, boolean>
  notifications: any[]
  setTheme: (theme: 'light' | 'dark') => void
  toggleSidebar: () => void
  openModal: (name: string) => void
  closeModal: (name: string) => void
  addNotification: (notification: any) => void
  removeNotification: (id: string) => void
}

export function useUIStore(): UIState {
  return create<UIState>((set) => ({
    theme: 'light',
    sidebarOpen: true,
    modals: {},
    notifications: [],
    setTheme: (theme) =>
      set(() => {
        if (typeof document !== 'undefined') {
          document.documentElement.classList.toggle('dark', theme === 'dark')
        }
        localStorage.setItem('theme', theme)
        return { theme }
      }),
    toggleSidebar: () =>
      set((state) => ({ sidebarOpen: !state.sidebarOpen })),
    openModal: (name) =>
      set((state) => ({
        modals: { ...state.modals, [name]: true },
      })),
    closeModal: (name) =>
      set((state) => ({
        modals: { ...state.modals, [name]: false },
      })),
    addNotification: (notification) =>
      set((state) => ({
        notifications: [...state.notifications, notification],
      })),
    removeNotification: (id) =>
      set((state) => ({
        notifications: state.notifications.filter((n) => n.id !== id),
      })),
  }))
}
